import { createReducer, on } from '@ngrx/store';
import { schoolActions } from '../actions/school.actions';
import { School } from '../models';

export interface SchoolState {
    loaded: boolean | null;
    loading: boolean | null;
    school: School | null;
    contactEmail: string | null;
}

export const initialState: SchoolState = {
    loaded: null,
    school: null,
    loading: null,
    contactEmail: null,
};

export const schoolReducer = createReducer(
    initialState,
    on(
        schoolActions.getSchool,
        (state): SchoolState => ({
            ...state,
            loaded: null,
        }),
    ),
    on(
        schoolActions.getSchoolSuccess,
        (state, { payload }): SchoolState => ({
            ...state,
            loaded: true,
            school: payload,
        }),
    ),
    on(
        schoolActions.getSchoolError,
        (state): SchoolState => ({
            ...state,
            loaded: false,
        }),
    ),
    on(
        schoolActions.getContactEmailSuccess,
        (state, { payload }): SchoolState => ({
            ...state,
            contactEmail: payload,
        }),
    ),
    on(
        schoolActions.clear,
        (): SchoolState => ({
            ...initialState,
        }),
    ),
);
